import { create } from 'zustand'
import { authApi, type AuthUser } from '@/lib/api/auth'
import { useMockApi } from '@/lib/api/client'

interface AuthState {
  user: AuthUser | null
  loading: boolean
  checked: boolean
  login: (password: string) => Promise<void>
  logout: () => Promise<void>
  checkSession: () => Promise<void>
}

const mockUser: AuthUser = {
  id: 'mock-user',
  displayName: 'Dev User',
  email: 'dev@local',
}

export const useAuthStore = create<AuthState>((set) => ({
  user: useMockApi() ? mockUser : null,
  loading: false,
  checked: useMockApi(),

  login: async (password: string) => {
    set({ loading: true })
    try {
      const user = useMockApi()
        ? mockUser
        : await authApi.login(password)
      set({ user, checked: true, loading: false })
    } catch (error) {
      set({ loading: false })
      throw error
    }
  },

  logout: async () => {
    if (!useMockApi()) {
      await authApi.logout()
    }
    set({ user: null, checked: true })
  },

  checkSession: async () => {
    if (useMockApi()) {
      set({ user: mockUser, checked: true })
      return
    }

    set({ loading: true })
    try {
      const user = await authApi.me()
      set({ user, checked: true, loading: false })
    } catch {
      set({ user: null, checked: true, loading: false })
    }
  },
}))
